$(document).ready(function(){
  accordion.init();
  navigation.init();
  popup.init();
  slider.init();
  
  
});
